import {FC, Suspense, lazy} from 'react'
import {Route, Routes, Navigate} from 'react-router-dom'
import {useClientPortalAuth} from '../modules/auth/core/ClientPortalAuth'
import {LayoutSplashScreen} from '../../_metronic/layout/core'
import {ClientPortalLayout} from '../modules/client-portal/layout/ClientPortalLayout'

const ClientPortalDashboard = lazy(() => import('../modules/client-portal/pages/ClientPortalDashboard'))
const ClientPortalSelectAccess = lazy(() => import('../modules/client-portal/pages/ClientPortalSelectAccess'))
const ClientPortalProjectPage = lazy(() => import('../modules/client-portal/pages/ClientPortalProjectPage'))

const ClientPortalRoutes: FC = () => {
  const {user, loading, selectedAccess} = useClientPortalAuth()

  if (loading) {
    return <LayoutSplashScreen />
  }

  if (!user) {
    return <Navigate to='/auth/area-do-cliente/login' replace />
  }

  // Check if user needs to select an access
  // User needs selection if:
  // 1. Has multiple different instances (not all from same instance) AND
  // 2. No access is selected
  const uniqueInstances = user.accesses ? new Set(user.accesses.map((acc: any) => acc.instance_id)) : new Set()
  const hasMultipleInstances = uniqueInstances.size > 1
  const needsSelection = hasMultipleInstances && !selectedAccess

  return (
    <ClientPortalLayout>
      <Suspense fallback={<LayoutSplashScreen />}>
        <Routes>
          {needsSelection ? (
            <>
              <Route path='select-access' element={<ClientPortalSelectAccess />} />
              <Route path='dashboard' element={<ClientPortalSelectAccess />} />
              <Route index element={<Navigate to='/area-do-cliente/select-access' replace />} />
              <Route path='*' element={<Navigate to='/area-do-cliente/select-access' replace />} />
            </>
          ) : (
            <>
              <Route path='dashboard' element={<ClientPortalDashboard />} />
              <Route path='project/:projectId' element={<ClientPortalProjectPage />} />
              <Route index element={<Navigate to='/area-do-cliente/dashboard' replace />} />
              <Route path='*' element={<Navigate to='/area-do-cliente/dashboard' replace />} />
            </>
          )}
        </Routes>
      </Suspense>
    </ClientPortalLayout>
  )
}

export {ClientPortalRoutes}

